import React from 'react';
import '../../Styles/iconLarge.css'

const IconLarge = ({iconL}) => {
    return(
        <div className="o-il"><img src={iconL} className="img-fluid" alt="" /></div>
    );
};
export default IconLarge;